import * as React from 'react';
import { SelectBase } from './SelectBase';
import type { ISelectBaseProps, ISelectChangeMeta, SelectOptionValue } from './types';

export interface ISingleSelectProps<
	TValue extends SelectOptionValue = SelectOptionValue,
	TMetadata = unknown
> extends Omit<ISelectBaseProps<TValue, TMetadata>, 'onChange' | 'selectionMode' | 'value'> {
	onChange: (value: TValue | null, meta: ISelectChangeMeta<TValue, TMetadata>) => void;
	value?: TValue | null;
}

export const SingleSelect = <
	TValue extends SelectOptionValue = SelectOptionValue,
	TMetadata = unknown
>({
	onChange,
	value,
	...props
}: ISingleSelectProps<TValue, TMetadata>): React.ReactElement => {
	const selectedValue = React.useMemo<ReadonlyArray<TValue>>(
		() => (value == null ? [] : [value]),
		[value]
	);

	const handleChange = React.useCallback(
		(nextValue: ReadonlyArray<TValue>, meta: ISelectChangeMeta<TValue, TMetadata>): void => {
			onChange(nextValue[0] ?? null, meta);
		},
		[onChange]
	);

	return <SelectBase {...props} onChange={handleChange} selectionMode="single" value={selectedValue} />;
};
